import { Route } from "react-router-dom";

import { VIEW_FINANCE_CATEGORY, VIEW_MATERIAL, VIEW_STAGE } from "src/constants";
import { LIBRARY_ROUTES } from "src/pages/library/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { Category } from "./category/Category.page";
import { Libraries } from "./Libraries.page";
import { Materials } from "./materials/Materials.page";
import { Stages } from "./stages";

/** Route tree for the library module, mounted under `/library`. */
export const libraryRoutes = (
  <Route path={LIBRARY_ROUTES.root}>
    <Route
      index
      element={<ProtectedRoute permissions={[VIEW_FINANCE_CATEGORY, VIEW_MATERIAL, VIEW_STAGE]} component={Libraries} />}
    />
    <Route
      path={LIBRARY_ROUTES.expenseCategories}
      element={<ProtectedRoute permissions={VIEW_FINANCE_CATEGORY} component={Category} />}
    />
    <Route path={LIBRARY_ROUTES.materials} element={<ProtectedRoute permissions={VIEW_MATERIAL} component={Materials} />} />
    <Route path={LIBRARY_ROUTES.stages} element={<ProtectedRoute permissions={VIEW_STAGE} component={Stages} />} />
  </Route>
);
